import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gestion_proyecto/manoObra';
import ManoObraList from './ManoObraList';

const ms2p = (state) => {
  return {
    ...state.proyecto_mano_obra,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ManoObraList);
